import { useReactiveVar } from '@apollo/client';
import {
  selectedAccessories,
  selectedExterior,
  selectedInterior,
  selectedModel,
  selectedMotor,
  selectedVersion,
} from '../../gqlCommon/graphql/cache';
import CategoryPurpose from '../../gqlCustomise/enum/CategoryPurpose';
import dxpDigitalDataAssignment from '../../../../common/utilities/dxpDigitalDataAssignment';
import { DxpDataLayerEventNames } from '../../../../common/utilities/customDatalayerInterface';
import { useCallback } from 'react';
import IFeature from '../../gqlCustomise/model/IFeature';
import ICategoryAttributes from '../../gqlCustomise/model/ICategoryAttributes';

const useDxpDataLayer = () => {
  const model = useReactiveVar(selectedModel);
  const versions = useReactiveVar(selectedVersion);
  const motor = useReactiveVar(selectedMotor);
  const interiorColor = useReactiveVar(selectedInterior);
  const exteriorColor = useReactiveVar(selectedExterior);
  const accessories = useReactiveVar(selectedAccessories);

  const commonEventPayload = {
    interiorColor,
    exteriorColor,
    model,
    motor,
    versions,
  };

  const resetPayload = () => {
    selectedExterior(null);
    selectedInterior(null);
    selectedAccessories(null);
    selectedModel(null);
    selectedVersion(null);
    selectedMotor(null);
  };

  const dxpHandleColorSelection = (category: string, value: string) => {
    if (category) {
      if (CategoryPurpose.INTERIOR_COLOUR === category) {
        selectedInterior(value);
        dxpDigitalDataAssignment({
          eventName: DxpDataLayerEventNames.CONFIGURATOR_INTERIOR,
          ...commonEventPayload,
          interiorColor: value,
        });
      }

      if (CategoryPurpose.EXTERIOR_COLOUR === category) {
        selectedExterior(value);
        dxpDigitalDataAssignment({
          eventName: DxpDataLayerEventNames.CONFIGURATOR_EXTERIOR,
          ...commonEventPayload,
          exteriorColor: value,
        });
      }
    }
  };

  const setInitialColors = useCallback(
    (features: IFeature[], categoryAttributes: ICategoryAttributes) => {
      if (categoryAttributes.categorypurpose === CategoryPurpose.INTERIOR_COLOUR && !interiorColor) {
        selectedInterior(features[0].name);
      }
      if (categoryAttributes.categorypurpose === CategoryPurpose.EXTERIOR_COLOUR && !exteriorColor) {
        selectedExterior(features[0].name);
      }
    },
    [interiorColor, exteriorColor],
  );

  return {
    model,
    versions,
    motor,
    accessories: accessories?.toString() || '',
    interiorColor,
    exteriorColor,
    dxpHandleColorSelection,
    commonEventPayload,
    resetPayload,
    setInitialColors,
  };
};

export default useDxpDataLayer;
